import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=6ee5b8a6&"
import script from "./FormView.vue?vue&type=script&lang=js&"
export * from "./FormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports